import React from 'react';
import { motion } from 'framer-motion';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { galleryImages, videoHighlights } from '../data/siteContent';
import heroImage from '../images/nepa-dono.png';

const Gallery = () => {
  return (
    <div className="gallery-page page-load-shell">
      <SEO
        title="Gallery | Uttam Diabetes Care Patna"
        description="View the Uttam Diabetes Care gallery with real clinic photos, doctor visuals, consultation highlights, and patient care videos from Patna and connected centers."
        keywords="diabetes clinic gallery Patna, doctor gallery Bihar, patient care videos Patna, Uttam Diabetes photos, clinic images Patna"
      />
      <TopBar />
      <Navbar />

      <section className="hero-section">
        <div className="hero-image">
          <img src={heroImage} alt="Gallery" />
        </div>
        <div className="hero-overlay">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Gallery</h1>
            <p>Real diabetes clinic photos, doctor visuals, and patient care videos from the project media collection</p>
          </motion.div>
        </div>
      </section>

      <section className="gallery-content">
        <div className="container">
          <div className="centers-heading">
            <span className="section-kicker">Real media</span>
            <h2 className="section-title">Clinic, Doctor & Patient Highlights</h2>
            <p className="centers-disclaimer">
              This gallery now uses actual image and video assets available in the project instead of
              stock placeholders.
            </p>
          </div>

          <motion.div
            className="gallery-grid"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            {galleryImages.map((img, index) => (
              <motion.div
                key={`${img.alt}-${index}`}
                className="gallery-item"
                whileHover={{ scale: 1.03 }}
                transition={{ duration: 0.3 }}
              >
                <img src={img.src} alt={img.alt} />
              </motion.div>
            ))}
          </motion.div>

          <div className="video-gallery" style={{ marginTop: '60px' }}>
            <span className="section-kicker">Real videos</span>
            <h2>Featured Videos</h2>
            <div className="video-showcase-grid">
              {videoHighlights.map((video) => (
                <div key={video.id} className="video-showcase-card">
                  <video className="showcase-video" controls preload="metadata" poster={video.poster}>
                    <source src={video.src} type="video/mp4" />
                  </video>
                  <p className="video-title">{video.title}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Gallery;
